module.exports = [
  {
    cardId: 1,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/student_registration.svg`,
    title: "CET Registration",
    linkText: "Register Now",
    openModal: true,
    moreLinks: [
    
  ],
  },
  {
    cardId: 2,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/edit_profile.svg`,
    title: "Profile",
    linkText: "Edit Profile",
    editModal: true,
  },
  {
    cardId: 3,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/admin_card.svg`,
    title: "Centralized Admission Process (CAP) Registration",
    linkText: "Register Now",
    capModal: true,
    moreLinks: [
      
    ]
  },
  {
    cardId: 4,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/student_registration.svg`,
    title: "MOCK & Psychometric Test",
    linkText: "Register Now",
    linkUrl: "https://mocktest.mahacet.org/RegistrationModule/frmRegistrationDetails",
  },
  {
    cardId: 5,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/support-ticket.svg`,
    title: "Help Desk",
    linkText: "Create or Track Issues",
    linkUrl: "https://helpdesk-2026.maharashtracet.org/login.php?do=ext&bk=oauth2.user.p1i4",
  },
  {
    cardId: 6,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/hall_ticket.svg`,
    title: "Hall Ticket or Admit Card",
    linkText: "Get Hall Ticket",
    openModal: true,
    moreLinks: [
      
    ],
  },
  {
    cardId: 7,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/objection_tracking.svg`,
    title: "Objection Tracker",
    linkText: "Track Here",
    openModal: true,
    moreLinks: [
      
    ],
  },
  {
    cardId: 8,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/score_card.svg`,
    title: "Score Card",
    linkText: "Get Score Card",
    openModal: true,
    moreLinks: [
      
    ],
  }, 
  {
    cardId: 9,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/admin_card.svg`,
    title: "ARA",
    linkText: "Get Details",
    linkUrl: "",
  },
  {
    cardId: 10,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/notification.svg`,
    title: "Notifications",
    linkText: "Get Details",
    linkUrl: "https://cetcell.mahacet.org/notices/",
  },
];
